// extracted by mini-css-extract-plugin
module.exports = {"ratings":"Ratings_ratings__m3lQg","lastRating":"Ratings_lastRating__smTd1"};